import * as constants from "./../constants";
//TODO: define columns type in an interface since its being used multiple times
export interface RequestColumnsAction {
  type: constants.REQUEST_COLUMNS;
}

export interface ReceiveColumnsAction {
  type: constants.RECEIVE_COLUMNS;
  data: {
    [key: string]: {title:string};
  }
}

export function requestColumns(): RequestColumnsAction {
  return {
    type: constants.REQUEST_COLUMNS,
  };
}

export function receiveColumns(data: {[key:string]: {title:string}}): ReceiveColumnsAction {
  return {
    type: constants.RECEIVE_COLUMNS,
    data,
  };
}
